import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import env from "../config/env";

const MyAnalytics = props => {
    const navigate = useNavigate();
    const initializeGA = (measurementId) => {
        let script1 = document.createElement('script');
        script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
        script1.async = true;
        document.body.appendChild(script1);
        let script2 = document.createElement('script');
        script2.text = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${measurementId}');`;
        document.body.appendChild(script2);
    };

    useEffect(() => {
        initializeGA(env.GOOGLE_ANALYTICS_ID);
    }, []);

    return null;
}

export default MyAnalytics;
